import { toast } from "react-toastify";

import { DELETE } from "./axios.service";
import { toastStyles } from "../static/styles";

// Deletes a turning receive and shows the backend's message; true once it is deleted. The receive list and the
// turning order page both delete receives.
export const deleteTurningReceive = async (id: number) => {
  try {
    const response: any = await DELETE(`/v1/admin/turning-receives/${id}`);

    if (response?.data?.status === "success") {
      toast.success(response.data.message, {
        ...(toastStyles as any),
      });
      return true;
    }

    toast.error(response?.data?.message, {
      ...(toastStyles as any),
    });
  } catch (error: any) {
    toast.error(
      error?.data?.message || "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.",
      {
        ...(toastStyles as any),
      }
    );
  }

  return false;
};
